import { useTranslation } from "react-i18next"
import { Grid, Modal, IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { Dispatch, SetStateAction, useState } from "react"
import { AbsencePopupWrapper, CloseIconWrapper } from "./styles"
import LoadingWrapper from "../../../../../../../../src/components/LoadingWrapper"
import { use } from "i18next"
import { useRTL } from "@hooks/useIsRTL"


interface IProps {
	onClick?: () => void
	isOpen: boolean
	setIsOpen: Dispatch<SetStateAction<boolean>>
	loading?: boolean
}

export default function AbsensePopup({ onClick,isOpen, setIsOpen,loading=false }: IProps) {
	const { t } = useTranslation()
	const {isRTL}=useRTL()

	

	return (
		<Modal open={isOpen} onClose={() => setIsOpen(false)}>
			<LoadingWrapper  loading={loading}>
			<AbsencePopupWrapper >
				<div className='containerPopup'>
					<CloseIconWrapper isRTL={isRTL}  className='header'>
					<CloseIcon onClick={() => setIsOpen(false)}/>
					</CloseIconWrapper>
					<h1>{t("MANUALRESERVATION.COMMON.CONFIRM_CANCEL_BOOKING")}</h1>
					<p>{t("MANUALRESERVATION.COMMON.ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_GUEST_RESERVATION")}</p>
					<div className='containerFooter'>
						<button onClick={onClick}  className='confirmBtn'>{t("MANUALRESERVATION.CONFIRM")}</button>
						<button onClick={() => setIsOpen(false)} className='cancelBtn'>{t("MANUALRESERVATION.CANCEL")}</button>
					</div>
				</div>
			</AbsencePopupWrapper>
		</LoadingWrapper>
		</Modal>
	)
}
 